import { toBeLogDateTime } from 'utils/apiDateTime';

export const getBeErrorDetail = (error, versionFE, versionBE) => {
	const request = error.request;
	const content = error.parsedContent ? error.parsedContent : {};
	const detail = content.detail && content.detail.replace(/\n/g, ' ').replace(/{/g, ' { ').replace(/}/g, ' } ');
	const member = error.responseHeaders && error.responseHeaders.get && error.responseHeaders.get('member');
	const rid = error.responseHeaders && error.responseHeaders.get && error.responseHeaders.get('RID');

	const output = [];
	versionFE && versionBE && output.push(`||version:| ${versionFE}✦${versionBE}|`);
	error.screenId &&
		output.push(
			`||screenId:| ${new RegExp(/GKCL-/).test(error.screenId) ? error.screenId : `GKCL-${error.screenId}`}|`,
		);
	content.status && output.push(`||status:| ${content.status}|`);
	content.message && output.push(`||message:| ${content.message}|`);
	if (content.timestamp) {
		output.push(`||timestamp:| ${toBeLogDateTime(content.timestamp)}|`);
	} else {
		output.push(`||timestamp:| ${toBeLogDateTime(new Date())} (client time)|`);
	}
	content.detail && output.push(`||detail:| ${detail}|`);
	member && output.push(`||member:| ${member}|`);
	rid && output.push(`||RID:| ${rid}|`);
	content.errorId && output.push(`||errorId:| ${content.errorId}|`);
	content.code && output.push(`||errorCode:| ${content.code}|`);
	content.type && output.push(`||errorType:| ${content.type}|`);
	content.exception && output.push(`||exception:| ${content.exception}|`);
	content.path && output.push(`||path:| ${content.path}|`);
	if (request) {
		request.endpoint && output.push(`||endpoint:| ${request.endpoint}|`);
		request.method && output.push(`||method:| ${request.method}|`);
		request.body && output.push(`||body:| ${request.body}|`);
	}
	if (content.validationErrors) {
		output.push('\nvalidationErrors:');
		output.push('||code||type||fieldName||objectName||message||fieldUpdatedValue||');
		content.validationErrors.forEach((item) => {
			// eslint-disable-next-line max-len
			output.push(
				`|${item.code}|${item.type}|${item.fieldName}|${item.objectName}|${item.message}|${item.fieldUpdatedValue}|`,
			);
		});
	}
	typeof content === 'string' && output.push(`\nresponse:\n{code}\n${content}{code}\n`);
	content.stacktrace && output.push(`\nstacktrace:\n{code}\n${content.stacktrace}{code}\n`);

	return output;
};
